<template>
    <div>
        <el-table
                :data="tableData"
                :height="ToDotableheight"
                :cell-class-name="getCellName"
                size="mini"
                stripe
                border
                :show-header="ShowHead"
                @row-click="rowClick"
                style="width: 100%;">
            <el-table-column
                    width="50"
                    label="序"
                    align="center">
                <template slot-scope="scope">
                    {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
                </template>
            </el-table-column>
            <el-table-column
                    v-if="ShowErpSerial"
                    prop="erpserial"
                    label="单号"
                    width="150"
                    align="left"
                    header-align="center">
                <template slot-scope="scope">
                    {{scope.row.erpserial}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="handlename"
                    label="标题"
                    align="left"
                    header-align="center">
                <template slot-scope="scope">
                  <span style="font-size: 14px">{{scope.row.handlename}} {{scope.row.shownumber}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="senduname"
                    align="left"
                    header-align="center"
                    label="发送人"
                    width="160" v-if="searchdata.todo=='100'">
                <template slot-scope="scope">
                    {{scope.row.senduname}}<br>{{scope.row.showdate}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="hddate"
                    align="left"
                    header-align="center"
                    label="办理"
                    width="160" v-if="searchdata.todo!='100'">
                <template slot-scope="scope">
                    {{scope.row.stepname}}<br>{{scope.row.showdate}}
                </template>
            </el-table-column>
            <!--<el-table-column-->
            <!--label="操作"-->
            <!--align="center"-->
            <!--width="150">-->
            <!--<template slot-scope="scope">-->
            <!--<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">处理-->
            <!--</el-button>-->
            <!--</template>-->
            <!--</el-table-column>-->
        </el-table>
        <div class="foot" style="padding-left: 30px">
            <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination" :layout="layout"></Pagination>
            <comment v-bind:is="which_to_show" ref="DataContactEdit" @bindGrid="bindGrid"></comment>

        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {mytodo} from '@/api/wf/todolist';
    import workflowcomponents from '@/plugin/workflowcomponents.js'

    Vue.use(workflowcomponents);

    export default {
        name: 'TodoList',
        data() {
            return {
                which_to_show: "",
                searchdata: {
                    handlename: "",//标题
                    erpserial: "",//单号
                    begindate: "",
                    enddate: "",
                    beginsearchnumber: "",
                    endsearchnumber: "",
                    menuguid: "",
                    todo: "100",//100 代办；200 我启动的；300 已办
                },
                pagination: {
                    currentPage: 1,
                    pageSize: this.ToDopageSize,
                    total: 0
                },
                tableData: []
            }
        },
        props: {
            ToDopageSize: {
                default: 0
            },
            ToDotableheight: {
                default: "205"
            },
            ShowHead: {
                default: true
            },
            ShowErpSerial: {
                default: false
            },
            layout: {
                default: "total, sizes, prev, pager, next, jumper"
            },
            defaulttodo: {
                default: "100"
            }
        },
        methods: {
            getCellName(rowdata) {
                return "todoCell";
            },
            formatShortDate(date) {
                return date;
            },
            todoEdit(index, row) {
                this.$refs.DataContactEdit.initData(row.serialnum)
            },
            initData(searchData) {
                this.pagination.currentPage = 1;
                this.searchdata = searchData;
                this.bindGrid();
            },
            rowClick(row, event, column) {
                if (row.turl && row.turl != '') {
                        if (this.which_to_show != row.turl) {
                          this.which_to_show = row.turl;
                          this.$nextTick(() => {
                            this.$refs.DataContactEdit.editPage(row.casefvid);
                            // event.target.click();
                          })
                        } else {
                          this.$refs.DataContactEdit.editPage(row.casefvid);
                    }
                }
            },
            bindGrid() {
                this.searchdata.offset = (this.pagination.currentPage - 1) * this.pagination.pageSize;
                this.searchdata.limit = this.pagination.pageSize;
                mytodo(this.searchdata).then(response => {
                    if (response.data.obj) {
                        this.tableData = response.data.obj.rows
                        this.pagination.total = response.data.obj.total;
                        this.$emit('afterBindTodo', this.tableData);
                    }
                }).catch((error) => {
                    console.log(error)
                });
            },
        },
        mounted() {
            this.searchdata.todo = this.defaulttodo;
            this.bindGrid();
        },
        components: {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .todoCell .cell {
        line-height: 16px !important;
        cursor: pointer;
    }

    /*.el-table td, .el-table div, .el-table .cell {*/
    /*line-height: 23px;*/
    /*padding: 0px;*/
    /*color: red;*/
    /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/workflow/Todolist.vue